


















import Company from "@/model/company";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import companyApi from "@/api/companyApi";
@Component({
  name: "qCompanySelect",
  components: {},
  directives: {},
  watch: {
    roleId: function() {
      this.getList();
    },
    mcCompanyId: function() {
      this.getList();
    },
  }
})
export default class QCompanySelect extends Vue {
  @Prop()
  value;
  @Prop({ default: "" })
  roleId;
  @Prop({ default: function(){
    return null;
  }})
  mcCompanyId;

  public companies: Company[] = [];
  public selected = null;

  mounted() {
    this.selected = this.value;
    // console.log(this.selected)
    this.getList();
  }

  @Watch("value")
  updateValue() {
    this.selected = this.value;
  }

  public changed() {
    this.$emit("input", this.selected);
  }

  public async getList() {
    const result = await companyApi.list({
      role_id: this.roleId,
      mcCompanyId: this.mcCompanyId
    });
    if (result) {
      this.companies = result;
    }
  }
}
